'use strict';

import React from 'react';
import { useState, useEffect, useMemo } from 'react';
import { Table, Button } from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';

import Loader from '../helper/Loader';

import TableHeader from '../helper/TableHeader';

import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    getFilteredRowModel,
    useReactTable,
} from '@tanstack/react-table';

const columnHelper = createColumnHelper();


function Registrations() {
    const { request } = useRequest();

    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);

    const [orgRegistrations, setOrgRegistrations] = useState(false);
    //const [registrations, setRegistrations] = useState(false);

    

    useEffect(() => {
        const fetchData = async () => {
            try {
                let result = await request("/Operator/GetRegistrations");
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        toast.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten.");
                    }
                }
                else {
                    setOrgRegistrations(json.registrations);
                }
            }
            catch (ex) {
                console.error(ex);
                toast.error("Es ist ein Fehler aufgetreten.");
            }
        };
        fetchData();
    }, []);

    const registrations = useMemo(() => {
        if (orgRegistrations === false) return false;

        return orgRegistrations.map(reg => {
            var c = { ...reg, FirstName: reg.FirstName + " " + reg.LastName };

            if (reg.Role == "school") {
                c.Role = "Schule";
            } else if (reg.Role == "business") {
                c.Role = "Unternehmen";
            }

            c.Street = reg.Street + " " + reg.HouseNo + ", " + reg.PostCode + " " + reg.City;
            return c;
        });
    }, [orgRegistrations]);

    const columns = [
        columnHelper.accessor('Email', {
            header: () => <span>E-Mail</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
            sortingFn: 'alphanumeric',
        }),
        columnHelper.accessor('FirstName', {
            header: () => <span>Name</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
            sortingFn: 'alphanumeric'
        }),
        columnHelper.accessor('Username', {
            header: () => <span>Benutzername</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
            sortingFn: 'alphanumeric',
        }),
        columnHelper.accessor('OrganisationName', {
            header: () => <span>Organisation</span>,
            cell: info => {
                if (info.row.original.Role == "Unternehmen") {
                    return <a href={"/Operator/School/" + info.row.original.OrganisationID}>{info.row.original.OrganisationName}</a>;
                } else if (info.row.original.Role == "Schule") {
                    return <a href={"/Operator/Business/" + info.row.original.OrganisationID}>{info.row.original.OrganisationName}</a>;
                }
            },
            enableColumnFilter: true,
            sortingFn: 'alphanumeric',
        }),
        columnHelper.accessor('Role', {
            header: () => <span>Typ</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
            filterFn: (row, _columnId, value) => {
                if (value.length == 0) return true;
                return value.map(m => m.value).indexOf(row.original.Role) > -1;
            },
            meta: {
                filterComponent: "select",    
            }
        }),
        columnHelper.accessor('Street', {
            header: () => <span>Adresse</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
            enableSorting: false,
        }),
        columnHelper.accessor('UserID', {
            header: () => <span></span>,
            cell: info => {
                return <div className="text-end"><Button href={"/Operator/Registration/" + info.getValue()} size="sm" variant="primary">Details</Button></div>;
            },
            enableSorting: false,
            enableColumnFilter: false,
        }),
    ]

    const reactTable = useReactTable({
        data: registrations || [],
        columns,
        state: {
            sorting,
            columnFilters,
        },
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,

        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    });

    if (registrations === false) return <Loader />

    return (
        <Table striped>
            <thead>
                {reactTable.getHeaderGroups().map(headerGroup => (
                    <TableHeader key={headerGroup.id} table={reactTable} headerGroup={headerGroup} flexRender={flexRender} />
                ))}
            </thead>
            <tbody>
                {reactTable.getRowModel().rows.map(row => (
                    <tr key={row.id}>
                        {row.getVisibleCells().map(cell => {
                            return (
                                <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            )
                        })}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}



export default Registrations;